import React, { useEffect, useState } from "react";
import { Modal } from "components";

import styles from "./styles.module.css";
import { AppUpdateSvg, ShineLogoFa } from "assets/images";
import Button from "components/Button";
import { InfoCircle } from "iconsax-react";
import useColors from "utils/Colors";
import { useDispatch } from "react-redux";

import { actions as commonActions } from "../../store/commonRedux/actions";

const InfoAppModal = ({ isOpen, setIsOpen }) => {
  const Colors = useColors();

  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={() => dispatch(commonActions.setInfoModal(true))}
      zIndex={21}
    >
      <div className={styles.content}>
        <div className="d-flex align-items-center">
          <InfoCircle size={24} color={Colors.Primary["5"]} />
          <h4 className={styles.title}>اطلاعیه</h4>
        </div>
        <p className={styles.desc}>
          {`مشتریان محترم سامانه شاین بگ،

ضمن عرض سلام به اطلاع می‌رساند نظر به تعطیلی و محدودیت های لجستیکی اعمال شده در پی مراسم تشییع پیکر رهبر فقید جمهوری اسلامی ایران، خدمات رسانی این سامانه تا پایان این مراسم متوقف می باشد.`}
        </p>
        <Button
          className="w-100"
          ghost={true}
          onClick={() => dispatch(commonActions.setInfoModal(true))}
        >
          متوجه شدم
        </Button>
      </div>
    </Modal>
  );
};

export default InfoAppModal;
